export const createErrorFactory = (context: string) => (text: string) => {
  return Error(`${context}: ${text}`);
};
